// src/i18n/displayKeys.js
// The contract that keeps translation from corrupting data. Product data objects
// interleave copy with config in the same literal, e.g.
//   { id: 'beginner', label: 'New', sub: 'Just starting…', weights: {}, routes: 'A' }
// Only allowlisted keys are ever swapped. Everything else — ids, slugs, hrefs,
// icon names, scoring weights — passes through untouched.

// Checked FIRST and wins over DISPLAY_KEYS. `value`, `name`, `type`, and `role`
// appear in this codebase as both copy and config, so they are denied outright
// rather than guessed at; any genuine copy under those keys is handled with
// t() at the component instead. `role` specifically collides across:
// data/products/paneLabData.js (pane layout slot enum: 'portrait'/'row'/'hero'/
// 'side'/'feature'/'small'/'wide'/'cell'), data/quiz/runwayData.js (engine
// routing tag: 'primary-tool'/'scanner'/'bundle'), and
// features/chatbot/ChatWidget.jsx (message enum: 'user'/'assistant') — vs.
// genuine testimonial author role copy (e.g. "Swing trader") elsewhere.
export const NEVER_TRANSLATE_KEYS = new Set([
  'id', 'slug', 'href', 'url', 'to', 'src', 'icon', 'iconName', 'image',
  'sceneKey', 'weights', 'routes', 'stage', 'variant', 'key', 'type',
  'platform', 'className', 'style', 'color', 'value', 'name', 'videoId',
  'anchor', 'target', 'rel', 'preset', 'mode', 'role',
]);

export const DISPLAY_KEYS = new Set([
  'title', 'subtitle', 'eyebrow', 'heading', 'subheading',
  'body', 'text', 'copy', 'description', 'sub', 'note', 'caption',
  'cta', 'ctaLabel', 'linkLabel', 'label', 'buttonText',
  'alt', 'imageAlt', 'ariaLabel', 'placeholder',
  'seoTitle', 'seoDescription',
  'question', 'answer', 'quote', 'author',
  'headline', 'subline', 'why', 'tierLabel',
  'titleLead', 'titleAccent', 'titleStart', 'titleGradient', 'titleAccentWord',
  'gradientWord', 'accentLabel', 'blurb', 'sectionEyebrow', 'navLabel', 'tag',
  'heroTitle', 'heroKicker', 'metaLine', 'chromeLabel', 'disclaimer',
]);

export const SENTENCE_ARRAY_KEYS = new Set([
  'heroPoints', 'titleLines', 'bullets', 'points', 'items', 'lines', 'features',
]);

export function isDisplayKey(key) {
  if (NEVER_TRANSLATE_KEYS.has(key)) return false;
  return DISPLAY_KEYS.has(key);
}

export function isSentenceArrayKey(key) {
  if (NEVER_TRANSLATE_KEYS.has(key)) return false;
  return SENTENCE_ARRAY_KEYS.has(key);
}
